import * as actionTypes from "../actions/actionTypes";

const initialState = {
  meetingId: "",
  meetingName: "",
  attendees: [],
  host: "",
  videoUrl: "",
  loading: false,
};

const specificMeetingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SPECIFIC_MEETING_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_SPECIFIC_MEETING_DETAILS_SUCCESS:
      return {
        ...state,
        meetingId: action.meetingid,
        meetingName: action.meetingName,
        attendees: action.attendees,
        host: action.host,
        loading: false,
      };
    case actionTypes.GET_SPECIFIC_MEETING_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.GET_SPECIFIC_MEETING_RECORDING_START:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_SPECIFIC_MEETING_RECORDING_SUCCESS:
      return {
        ...state,
        videoUrl: action.videoUrl,
        loading: false,
      };
    case actionTypes.GET_SPECIFIC_MEETING_RECORDING_FAIL:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.CLEAR_SPECIFIC_MEETING_STATES:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default specificMeetingReducer;
